import { About } from './view/about';
import { Reputation } from './view/reputation';
import { Activity } from './view/activity';
import { Notifications } from './view/notifications';
import { OrderHistory } from './view/order_history/display';
import { Contributions } from './view/contributions';
import { _js } from '@ifixit/utils/localize';

// Type definitions for user tabs
interface UserTab {
   name: 'About' | 'Contributions' | 'Reputation' | 'Activity' | 'Notifications' | 'Orders';
   data: any; // This would ideally be a union of specific data types for each tab
   url: string;
}

interface CurrentViewPanelProps {
   userid: number;
   tab: UserTab;
   setUnreadNotifCount: (count: number) => void;
}

function CurrentViewPanel({ userid, tab, setUnreadNotifCount }: CurrentViewPanelProps) {
   switch (tab.name) {
      case 'About': {
         return <About userid={userid} data={tab.data} />;
      }
      case 'Contributions': {
         return <Contributions userid={userid} data={tab.data} />;
      }
      case 'Reputation': {
         return <Reputation userid={userid} data={tab.data} />;
      }
      case 'Activity': {
         return <Activity userid={userid} data={tab.data} />;
      }
      case 'Notifications': {
         return <Notifications data={tab.data} setUnreadNotifCount={setUnreadNotifCount} />;
      }
      case 'Orders': {
         return <OrderHistory data={tab.data} />;
      }
      default: {
         return <div>{_js('An error occurred.')}</div>;
      }
   }
}

interface UserViewProps {
   userid: number;
   currentTab: UserTab;
   setUnreadNotifCount: (count: number) => void;
}

export function UserView({ userid, currentTab, setUnreadNotifCount }: UserViewProps) {
   return (
      <div className="flex flex-col gap-9">
         <CurrentViewPanel
            userid={userid}
            tab={currentTab}
            setUnreadNotifCount={setUnreadNotifCount}
         />
      </div>
   );
}
